import { useLocation } from "react-router-dom";

export const useQueryParam = (param: string) => {
  const search = useLocation().search;
  const query = new URLSearchParams(search);
  return query.get(param);
};
